/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { t } from '@sportninja/common/i18n'
import { getDayjsTZDate, isOvertime } from '@sportninja/common/utils/utils'
import dayjs from 'dayjs'

export const getGameStatusLabel = (game_status_id, statusTypes) => {
  if (!statusTypes || !Array.isArray(statusTypes)) return ''
  const status = statusTypes.find((type) => type?.id === game_status_id)
  if (status?.name) return status.name
  return ''
}

export const getDateAndGameTime = (game) => {
  const localDate = dayjs(game.starts_at)
  const date = getDayjsTZDate(game.starts_at, game.venue?.timezone)
  const displayGameTime = date.format('z') !== localDate.format('z')
  return { localDate, date, displayGameTime }
}

export const getCurrentPeriod = (game, isSoccer = false) => {
  let currentPeriod = {}
  if (game?.current_period) {
    currentPeriod = {
      fullName: game.current_period.period_type.name_full,
      name: game.current_period.period_type.name,
      isOvertime: isOvertime(isSoccer, game?.current_period?.period_type?.id),
    }

    if (game.current_period.clock_time) {
      currentPeriod.clockTime = dayjs(
        game.current_period.clock_time,
        'hh:mm:ss'
      ).format('m:ss')
    }
  }
  return currentPeriod
}

const GameListRowTime = ({ game, gameStatusTypes, isSoccer = false }) => {
  const { localDate, date, displayGameTime } = getDateAndGameTime(game)
  const currentPeriod = getCurrentPeriod(game, isSoccer)

  return (
    <>
      <div
        className='game-row-game-time'
        css={css`
          font-weight: 500;
          font-size: 14px;
          color: white;
          margin-top: 8px;
        `}
      >
        <p>{localDate.format('MMMM D, YYYY - h:mm a (z)')}</p>
        <p>
          {displayGameTime &&
            date.format(
              localDate.day() !== date.day() ? 'MMM D - h:mm a z' : 'h:mm a z'
            )}
        </p>
      </div>
      {game.ended_at ? (
        <div
          className='game-row-final-text'
          css={css`
            font-weight: 500;
            font-size: 14px;
            color: ${colors.DEFAULT_FLAIR};
            text-transform: uppercase;
            margin-top: 8px;
          `}
        >
          {game.shootout
            ? 'Shootout'
            : currentPeriod.isOvertime
            ? isSoccer
              ? 'Extra Time'
              : 'Overtime'
            : t('util:capitalize', { text: t('common:final') })}
          {game.game_status_id > 1 &&
            ` - ${getGameStatusLabel(game.game_status_id, gameStatusTypes)}`}
          {game.stats_rolledback && (
            <span
              css={css`
                text-transform: capitalize;
              `}
            >
              {' -'} [In Review]
            </span>
          )}
        </div>
      ) : game.started_at ? (
        <div
          className='game-row-current-period-time'
          css={css`
            font-weight: 500;
            font-size: 14px;
            color: white;
            margin-top: 8px;
            text-transform: uppercase;
          `}
        >
          {currentPeriod.clockTime
            ? currentPeriod.fullName
            : currentPeriod.name}{' '}
          {currentPeriod.clockTime
            ? ` - ${currentPeriod.clockTime}`
            : t('util:capitalize', {
                text: t('GameScreen:intermission'),
              })}
        </div>
      ) : (
        false
      )}
    </>
  )
}

export default GameListRowTime
